import React from 'react';
import PropTypes from 'prop-types';
import findIndex from 'lodash/findIndex';
import cx from 'classnames';

import { PAGE_WEBINAR } from '../../../config/pages';

import WebinarHeader from './WebinarHeader';
import WebinarContent from './WebinarContent';
import Footer from '../common/Footer';
import Form from '../common/Form';
import { companyInfoPropsType } from '../../helpers/fetchCmsContent';

const Webinar = ({
    t, openPage, language, page, subpage, consents, claim, companyInfo
}) => {
    const webinarClassName = cx('container-webinar', {
        open: page === PAGE_WEBINAR
    });

    const webinars = t('webinar.list');

    let webinarIndex = null;
    let webinar = null;
    if (subpage !== null) {
        webinarIndex = findIndex(webinars, (o) => o.slug === subpage);
        if (webinarIndex !== -1) {
            webinar = webinars[webinarIndex];
        }
    }

    if (webinar === null) {
        return (
            <div/>
        );
    }

    return (
        <div className={ webinarClassName } id="container-webinar">
            <WebinarHeader
              webinar={ webinar }
            />
            <WebinarContent
              t={ t }
              openPage={ openPage }
              language={ language }
              webinar={ webinar }
              consents={ consents }
            />
            <Form type="bottom" t={ t } language={ language } formName="webinar-bottom" typeButton="offer" consents={ consents }/>
            <Footer t={ t } openPage={ openPage } language={ language } claim={ claim } companyInfo={ companyInfo }/>
        </div>
    );
};

Webinar.defaultProps = {
    subpage: null,
    companyInfo: null
};

Webinar.propTypes = {
    t: PropTypes.func.isRequired,
    openPage: PropTypes.func.isRequired,
    language: PropTypes.string.isRequired,
    page: PropTypes.string.isRequired,
    subpage: PropTypes.string,
    consents: PropTypes.objectOf(Object).isRequired,
    claim: PropTypes.string.isRequired,
    companyInfo: companyInfoPropsType
};

export default Webinar;



// WEBPACK FOOTER //
// ./src/components/content/webinar/Webinar.jsx